module.exports = __webpack_public_path__ + "static/media/homeleft.379e42c1.png";